import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { allocateTheUserMember_POST } from '../../api';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';

const SelectMemberPopup = ({ 
  show, 
  onHide, 
  members, 
  onProceedConfirm,
  isLoading,
  selectedTeamMember
}) => {

  const location = useLocation();
  const pointerData = location.state?.pointerData;

  const [selectedMemberId, setSelectedMemberId] = useState("");

  const handleProceed = () => {
    if (!selectedMemberId) {
      alert('Please select a member');
      return;
    }
    onHide();
    allocateTheUserMember();
  };

  const allocateTheUserMember = async() => {
    const formData = new FormData();
    formData.append("pointer_id", pointerData?.pointer_id);
    formData.append("member_id", selectedMemberId);


    try {
      const response = await allocateTheUserMember_POST(formData);
      if (
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {

        onProceedConfirm(selectedMemberId);
      } else {
        // console.error(
        //   "Error fetching assessment documents:",
        //   response?.data?.response?.error_msg || "Unknown error"
        // );
        toast.error("Try after sometime");
      }
    } catch (error) {
      // console.error("Error fetching assessment documents:", error);
      toast.error("Try after sometime");
    }
  }

  useEffect(() => {
  if (show) {
    setSelectedMemberId(selectedTeamMember || '');
  }
}, [show, selectedTeamMember]);


  return (
    <Modal 
      show={show}
      onHide={onHide}
      animation={false}
      backdrop="static"
      centered
      size="lg"
    >
      <Modal.Header style={{
        backgroundColor: '#FFCC01',
        color: '#055837'
      }}>
        <Modal.Title className='mx-auto d-block'>
          <h5 className="modal-title text-uppercase"><b>Team Member</b></h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <Form.Group controlId="memberSelect">
              {/* <Form.Label className="mb-3" style={{ fontWeight: 'bold' }}>
                Select Member:
              </Form.Label> */}
              <Form.Control
                as="select"
                value={selectedMemberId || ''}
                onChange={(e) => setSelectedMemberId(e.target.value)}
                className="mb-4 form-select"
              >
                <option value="" disabled>-- Select a team member --</option>
                {members.map(member => (
                  <option key={member.id} value={member.id}>
                    {member.name} {member.is_admin === 'yes' ? ' (Admin)' : ''}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button
          variant="secondary"
          className="me-3"
          onClick={onHide}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          style={{
            backgroundColor: '#055837',
            color: '#FFCC01',
            transition: "transform 0.2s",
          }}
          onClick={handleProceed}
          disabled={isLoading}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.02)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        >
          {isLoading ? 'Processing...' : 'Proceed'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectMemberPopup;